"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowFieldsQueryGrid = exports.mapResultNode = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
var react_1 = __importDefault(require("react"));
var queries_1 = require("../../../gen-src/queries");
var FieldFunctions_1 = require("../field/functions/FieldFunctions");
var FlowFieldsDisplayGrid_1 = require("./FlowFieldsDisplayGrid");
function selectConnectionListResult(resultData) {
    return resultData && resultData.flows && resultData.flows[0] &&
        resultData.flows[0].outputSteps[0] && resultData.flows[0].outputSteps[0].outputFieldsConnection;
}
function mapResultNode(_a, resultData) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var id = _a.id, name = _a.name, node = __rest(_a, ["id", "name"]);
    var rest = {
        flowVizportalUrlId: (_b = resultData.flows[0]) === null || _b === void 0 ? void 0 : _b.vizportalUrlId,
        id: id,
        name: name,
        fieldIcon: null,
        sheetCount: null,
    };
    switch (node.__typename) {
        case 'FlowFieldOutputField': return __assign(__assign({}, rest), { fieldIcon: (0, FieldFunctions_1.iconForField)(node.field), sheetCount: (_e = (_d = (_c = node.field) === null || _c === void 0 ? void 0 : _c.downstreamSheetsConnection) === null || _d === void 0 ? void 0 : _d.totalCount) !== null && _e !== void 0 ? _e : null });
        case 'FlowColumnOutputField': return __assign(__assign({}, rest), { remoteType: (_g = (_f = node.column) === null || _f === void 0 ? void 0 : _f.remoteType) !== null && _g !== void 0 ? _g : undefined, sheetCount: (_k = (_j = (_h = node.column) === null || _h === void 0 ? void 0 : _h.downstreamSheetsConnection) === null || _j === void 0 ? void 0 : _j.totalCount) !== null && _k !== void 0 ? _k : null });
        default:
            (0, vizportalclient_common_components_1.assertUnreachable)(node);
            return __assign(__assign({}, rest), { fieldIcon: null, sheetCount: null });
    }
}
exports.mapResultNode = mapResultNode;
function FlowFieldsQueryGrid(props) {
    return (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: queries_1.FlowFieldsByIdDocument, partialQueryVariables: {
            flowVizportalUrlId: props.flowVizportalUrlId,
            selectedOutputStepId: props.selectedOutputStepId,
            orderBy: props.orderBy,
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, function (_a) {
        var rowStore = _a.rowStore;
        return (react_1.default.createElement(FlowFieldsDisplayGrid_1.FlowFieldsDisplayGrid, { rowStore: rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
    }));
}
exports.FlowFieldsQueryGrid = FlowFieldsQueryGrid;
//# sourceMappingURL=FlowFieldsQueryGrid.js.map